// services/abstract/SixCatalogService.ts

import type { FetchSixesCatalogParams, SixesCatalogPayloadDTO, SixFavoriteDTO } from '@/types/SixCatalogDTOs';

export abstract class SixCatalogService {
  /**
   * Returns visible SIXes for the current user with optional filters and search.
   * @param params - Optional search query and filter keys
   * @returns Catalog payload with sixes and pagination
   */
  abstract fetchSixes(params?: FetchSixesCatalogParams): Promise<SixesCatalogPayloadDTO>;

  /** Deletes a SIX by its identifier. */
  abstract deleteSix(id: string): Promise<void>;

  /** Toggles the favorite state of a SIX. */
  abstract toggleFavoriteSix(id: string): Promise<SixFavoriteDTO>;
}
